// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function trackEventDummy(eventObject) {
  // do nothing
}

// if you were using Segment
export function trackEvent({ category, label, name, traits }) {
  if (!name) {
    throw new Error("The `name` field is required.");
  }

  if (traits) {
    window?.analytics?.track(
      name,
      {
        category,
        label,
        name,
      },
      {
        traits,
      }
    );
  } else {
    window?.analytics?.track(name, {
      category,
      label,
      name,
    });
  }
}
